import React, { useState } from "react";
import { Link } from "react-router-dom";

const Sidebar = ({ isOpen, close }) => {
  const [aboutOpen, setAboutOpen] = useState(false);
  const [academicOpen, setAcademicOpen] = useState(false);

  return (
    <div className={`sidebar-overlay ${isOpen ? "active" : ""}`}>

      {/* BACKDROP */}
      <div className="sidebar-backdrop" onClick={close}></div>

      {/* PANEL */}
      <div className="sidebar-panel">
        <button className="close-btn" onClick={close}>✕</button>

        <ul>

          <li>
            <Link to="/" onClick={close}>HOME</Link>
          </li>

          {/* ABOUT */}
          <li className="submenu-parent">

            <div
              className="submenu-title"
              onClick={() => setAboutOpen(!aboutOpen)}
            >
              <span>ABOUT</span>
              <span>{aboutOpen ? "▲" : "▼"}</span>
            </div>

            {aboutOpen && (
              <ul className="submenu-list">

                <li>
                  <Link to="/about?tab=history" onClick={close}>
                    History
                  </Link>
                </li>

                <li>
                  <Link to="/about?tab=aims" onClick={close}>
                    Aims & Objectives
                  </Link>
                </li>

                <li>
                  <Link to="/about?tab=director" onClick={close}>
                    Director's Desk
                  </Link>
                </li>

                <li>
                  <Link to="/about?tab=principal" onClick={close}>
                    Principal's Desk
                  </Link>
                </li>

                <li>
                  <Link to="/about?tab=coordinator" onClick={close}>
                    Coordinator's Desk
                  </Link>
                </li>

                <li>
                  <Link to="/about?tab=committee" onClick={close}>
                    Committee & Members
                  </Link>
                </li>

                <li>
                  <Link to="/about?tab=faculty" onClick={close}>
                    Faculty & Staff
                  </Link>
                </li>

                <li>
                  <Link to="/about?tab=awards" onClick={close}>
                    Awards & Medals
                  </Link>
                </li>

                <li>
                  <Link to="/about?tab=basic" onClick={close}>
                    Basic Details
                  </Link>
                </li>

              </ul>
            )}

          </li>

          <li>
            <Link to="/admission" onClick={close}>
              ADMISSION
            </Link>
          </li>

          <li>
            <Link to="/parents" onClick={close}>
              PARENTS
            </Link>
          </li>

          {/* ACADEMICS */}
          <li className="submenu-parent">

            <div
              className="submenu-title"
              onClick={() => setAcademicOpen(!academicOpen)}
            >
              <span>ACADEMICS</span>
              <span>{academicOpen ? "▲" : "▼"}</span>
            </div>

            {academicOpen && (
              <ul className="submenu-list">

                <li>
                  <Link
                    to="/academics?tab=details"
                    onClick={close}
                  >
                    Academics Details
                  </Link>
                </li>

                <li>
                  <Link
                    to="/academics?tab=overview"
                    onClick={close}
                  >
                    Overview
                  </Link>
                </li>

                <li>
                  <Link
                    to="/academics?tab=curriculum"
                    onClick={close}
                  >
                    Curriculum
                  </Link>
                </li>

                <li>
                  <Link
                    to="/academics?tab=student"
                    onClick={close}
                  >
                    Student Detail
                  </Link>
                </li>

                <li>
                  <Link
                    to="/academics?tab=timing"
                    onClick={close}
                  >
                    School Timing
                  </Link>
                </li>

                <li>
                  <Link
                    to="/academics?tab=dress"
                    onClick={close}
                  >
                    School Dress
                  </Link>
                </li>

                <li>
                  <Link
                    to="/academics?tab=exam"
                    onClick={close}
                  >
                    Exam Schedule
                  </Link>
                </li>

                {/* <li>
                  <Link
                    to="/academics?tab=fees"
                    onClick={close}
                  >
                    Fees Schedule
                  </Link>
                </li> */}

                <li>
                  <Link
                    to="/academics?tab=other"
                    onClick={close}
                  >
                    Other Vital Information
                  </Link>
                </li>

              </ul>
            )}

          </li>

          <li>
            <Link to="/mandatory-public-disclosure" onClick={close}>
              MANDATORY PUBLIC DISCLOSURE
            </Link>
          </li>

          <li>
            <Link to="/cbse-documents" onClick={close}>
              CBSE DOCUMENT
            </Link>
          </li>

          <li>
            <Link to="/infrastructure" onClick={close}>
              INFRASTRUCTURE
            </Link>
          </li>

          <li>
            <Link to="/life" onClick={close}>
              LIFE AT SCHOOL
            </Link>
          </li>

          <li>
            <Link to="/events" onClick={close}>
              EVENTS
            </Link>
          </li>

          <li>
            <Link to="/news" onClick={close}>
              NEWS
            </Link>
          </li>

          <li>
            <Link to="/gallery" onClick={close}>
              GALLERY
            </Link>
          </li>

          <li>
            <Link to="/facilities" onClick={close}>
              FACILITIES
            </Link>
          </li>

          <li>
            <Link to="/documents" onClick={close}>
              DOCUMENTS
            </Link>
          </li>

          <li>
            <Link to="/student-tc" onClick={close}>
              STUDENT TC
            </Link>
          </li>

          <li>
            <Link to="/contact" onClick={close}>
              CONTACT
            </Link>
          </li>

          <li>
            <Link to="/virtual-tour" onClick={close}>
              VIRTUAL TOUR
            </Link>
          </li>

          <div className="sidebar-bottom">
            <li>
              <Link to="/admin/login" onClick={close}>
                ADMIN LOGIN
              </Link>
            </li>
          </div>

        </ul>
      </div>
    </div>
  );
};

export default Sidebar;